import axios from 'axios';
import { getRequest, postRequest } from '../tools/ajax.js'

const ConflictList = params => postRequest('/api/pc/Conflict/ConflictList', params);

const ConflictCounselList = params => postRequest('/api/pc/Conflict/ConflictCounselList', params)

const BankruptcyConflictList = params => postRequest('/api/pc/Conflict/BankruptcyConflictList', params)

export {
    ConflictList,ConflictCounselList,BankruptcyConflictList
}